export class Environment {
    public static BACKEND_URL = 'https://eye.ace-adventure.net:4000';
}
